import {RecordsPeriod} from "../utils/dateRange"

export type DoctorStatsStateType = {
    fetching: boolean
    stats: DoctorStatsType | null
    availableRecords: Array<AvailableRecordType>
    availableRecordsFetching: boolean
    /**
     * The last available-records fetch failed.
     *
     * `availableRecordsFetching` cannot stand in for this: the epic answers
     * `setAvailableRecordsPage` without dispatching
     * `fetchAvailableRecordsAsync.request`, so that flag never rises for a page
     * change. A failure also leaves `availableRecords` at the same reference,
     * so there is otherwise NO observable difference between "request failed"
     * and "request still in flight".
     */
    availableRecordsError: boolean
    availableRecordsCurrentPage: number
    availableRecordsTotal: number
    availableRecordsSize: number
    availableRecordsPeriod: RecordsPeriod
    inProgressRecord: AvailableRecordType | null
    inProgressRecordFetching: boolean
}

export type DoctorStatByPeriod = {
    skipped: number
    reviewed: number
}

export type DoctorStatsType = {
    day: DoctorStatByPeriod
    week: DoctorStatByPeriod
    month: DoctorStatByPeriod
    alltime: DoctorStatByPeriod
}

export type AvailableRecordType = {
    doctorId: string,
    teleRecordId: string,
    status: RecordStatusEnum,
    normality: RecordNormalityEnum,
    time: string,
    folder: FolderNameEnum,
    fileName: string,
    recordType: string,
    age?: number | null,
    heartRate?: number | null,
    algorithmConclusion?: string | null,
}

export enum RecordStatusEnum {
    APPROVED = "APPROVED",
    NEW = "NEW",
    IN_PROGRESS = "IN_PROGRESS"
}

export enum FolderNameEnum {
    IT = "IT",
    FR = "FR"
}

export enum RecordNormalityEnum {
    ABNORMAL = "ABNORMAL",
    NORMAL = "NORMAL"
}